/* GoogleMapAllFacilities ID is used here to migrate all the
GoogleMapAllFacilities widgets to MapboxAllFacilities widgets */
export const ID = 'd0ac12d1-bacd-4cef-bd5a-db741ead96ef';
export const NAME = 'Map: All Facilities';
